import "../types/wootric";

export const WOOTRIC_SDK_URL = "https://cdn.wootric.com/wootric-sdk.js";

const WOOTRIC_SCRIPT_ATTRIBUTE = "data-wootric-sdk";

let loader: Promise<void> | null = null;

/**
 * Injects the Wootric SDK once per document, resolving once the SDK script has
 * executed. Callers must check `window.WootricSurvey` before using it.
 */
export const loadWootricSdk = (): Promise<void> => {
  if (window.WootricSurvey) {
    return Promise.resolve();
  }

  loader ??= new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = WOOTRIC_SDK_URL;
    script.setAttribute(WOOTRIC_SCRIPT_ATTRIBUTE, "");
    script.onload = () => resolve();
    script.onerror = () => {
      loader = null;
      script.remove();
      reject(new Error("Failed to load the Wootric SDK"));
    };

    document.head.appendChild(script);
  });

  return loader;
};
